module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/prepared@2x-c44cf797de0f4602c613553c97740aae.jpg";